import { AxiosPromise } from "axios"
import { usersApi } from "./api"
import { TokenPayload } from "app/models/token"

export const getRoles = (data: TokenPayload): AxiosPromise =>
  usersApi("/roles", { method: "GET", data })
